import { mallDomain } from '@/defines/domains'
import { request } from '../request'

export const tradegwApi = {
  async post(path, data) {
    try {
      const url = `${mallDomain}/tradegw/api${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
